"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _reshowConstant = require("reshow-constant");
var _index = _interopRequireDefault(require("./index.js"));
var _injectStyle = _interopRequireDefault(require("./injectStyle.js"));
//@ts-check

/**
 * @param {object} configs
 * @param {object} injects
 * @returns {injects}
 */
var lazyInject = function lazyInject(configs, injects) {
  if (!injects) {
    injects = (0, _reshowConstant.NEW_OBJ)();
    (0, _reshowConstant.KEYS)(configs).forEach(function (key) {
      var item = configs[key];
      if (!(0, _reshowConstant.IS_ARRAY)(item)) {
        item = [item];
      }
      injects[key] = _index["default"].apply(null, item);
    });
    (0, _injectStyle["default"])();
  }
  return injects;
};
var _default = exports["default"] = lazyInject;
module.exports = exports.default;